<script setup lang="ts">
/**
 * PoweredBy — dezenter Anbieter-Hinweis für den gebrandeten Kunden-Bereich.
 *
 * Bewusst leise (klein, gedämpftes Grau): branchenüblicher White-Label-/
 * Co-Branding-Standard + DSGVO-Transparenz (miraTEQ ist Auftragsverarbeiter).
 * Eine Stelle, ein Wortlaut — überall gleich gepflegt. Der eigentlich
 * rechtlich relevante Hinweis steht im AVV + in der Datenschutzerklärung
 * des Kunden, nicht hier; dies ist nur das sichtbare Transparenz-Plus.
 */
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <p class="text-center text-xs text-fg-muted">{{ t('ui.bereitgestellt_von') }}<a
      href="https://mirateq.com"
      target="_blank"
      rel="noopener"
      class="font-medium hover:text-fg underline-offset-2 hover:underline transition-colors"
    >miraTEQ</a>
  </p>
</template>
